import React from 'react';
import {
  string, bool, shape, oneOf, arrayOf
} from 'prop-types';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Metadata, HomepageMetadata, NoIndexNoFollowMetadata } from '@thd-olt-component-react/metadata';
import { staticMetadata } from './metadata-utils';

const HomepageMetadataContainer = ({
  isPreviewPage,
  preloadedImages,
  metadata
}) => {
  const hpMetadata = { ...staticMetadata, ...metadata };

  return (
    <ErrorBoundary name="metadata">
      <Metadata>
        {isPreviewPage && (
          <NoIndexNoFollowMetadata />
        )}
        <HomepageMetadata
          metadata={hpMetadata}
          preloadedImages={preloadedImages}
        />
      </Metadata>
    </ErrorBoundary>
  );
};

HomepageMetadataContainer.propTypes = {
  isPreviewPage: bool.isRequired,
  preloadedImages: arrayOf(shape({})).isRequired,
  metadata: shape({}).isRequired
};

HomepageMetadataContainer.defaultProps = {};

export { HomepageMetadataContainer };
